/* ==========================================================================
   Hotpot Info Pagina, Homepage & Productpagina — gedeelde interactie
   1. Blog: filterknoppen (tags) + horizontale slider met pijltjes
   2. FAQ (twee niveaus): categorieën in-/uitklapbaar, en binnen een categorie
      de eerste 3 vragen zichtbaar met "Bekijk meer / Toon minder".
      Gebruikt overal directe hidden-attributen — geen CSS-animatie die kan
      haperen door een conflicterende stijl elders op de pagina.
   3. Product-details accordion (los systeem, [data-open-first]).
   ========================================================================== */

(function () {
  'use strict';

  console.log('HOTpot info JS geladen');

  function initBlog() {
    var blogSections = document.querySelectorAll('[data-hotpot-blog]');

    blogSections.forEach(function (section) {
      var tabs = section.querySelectorAll('[data-hotpot-blog-tab]');
      var cards = section.querySelectorAll('[data-hotpot-blog-card]');
      var track = section.querySelector('[data-hotpot-blog-grid]');
      var prevBtn = section.querySelector('[data-hotpot-blog-prev]');
      var nextBtn = section.querySelector('[data-hotpot-blog-next]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          var filterTag = tab.dataset.filterTag;

          cards.forEach(function (card) {
            if (filterTag === '') {
              card.style.display = '';
              return;
            }
            var articleTags = card.dataset.articleTags || '';
            var tagList = articleTags.split(',').map(function (t) { return t.trim(); });
            card.style.display = tagList.indexOf(filterTag) !== -1 ? '' : 'none';
          });
        });
      });

      if (track) {
        var scrollByCard = function (direction) {
          var card = track.querySelector('.hotpot-info-recipe-card');
          var cardWidth = card ? card.getBoundingClientRect().width + 22 : 300;
          track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
        };

        if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
      }
    });
  }

  function initFaq(root) {
    var scope = root || document;
    var categoriesWrapper = scope.querySelector('[data-hotpot-faq-categorized], .hotpot-faq-categories');
    if (!categoriesWrapper) return;

    var categoryBlocks = categoriesWrapper.querySelectorAll('[data-hotpot-faq-category-block]');

    categoryBlocks.forEach(function (categoryBlock) {
      var toggleBtn = categoryBlock.querySelector('[data-hotpot-faq-category-toggle]');
      var body = categoryBlock.querySelector('[data-hotpot-faq-category-body]');
      var icon = toggleBtn ? toggleBtn.querySelector('.hotpot-faq-category-toggle__icon') : null;

      if (toggleBtn && body) {
        toggleBtn.addEventListener('click', function () {
          var isOpen = !body.hidden;

          categoryBlocks.forEach(function (otherBlock) {
            var otherBody = otherBlock.querySelector('[data-hotpot-faq-category-body]');
            var otherToggle = otherBlock.querySelector('[data-hotpot-faq-category-toggle]');
            var otherIcon = otherToggle ? otherToggle.querySelector('.hotpot-faq-category-toggle__icon') : null;
            if (otherBody) otherBody.hidden = true;
            if (otherIcon) otherIcon.textContent = '+';
            otherBlock.classList.remove('is-open');
          });

          if (!isOpen) {
            body.hidden = false;
            if (icon) icon.textContent = '−';
            categoryBlock.classList.add('is-open');
          }
        });
      }

      var items = categoryBlock.querySelectorAll('[data-hotpot-faq-item]');
      items.forEach(function (item) {
        var qBtn = item.querySelector('[data-hotpot-faq-toggle]');
        var answer = item.querySelector('[data-hotpot-faq-answer]');
        var qIcon = item.querySelector('.hotpot-info-faq-item__icon');

        if (!qBtn || !answer) return;

        qBtn.addEventListener('click', function () {
          var isOpen = !answer.hidden;

          items.forEach(function (otherItem) {
            var otherAnswer = otherItem.querySelector('[data-hotpot-faq-answer]');
            var otherIcon = otherItem.querySelector('.hotpot-info-faq-item__icon');
            if (otherAnswer) otherAnswer.hidden = true;
            if (otherIcon) otherIcon.textContent = '+';
            otherItem.classList.remove('is-open');
          });

          if (!isOpen) {
            answer.hidden = false;
            if (qIcon) qIcon.textContent = '−';
            item.classList.add('is-open');
          }
        });
      });

      var extraItems = categoryBlock.querySelectorAll('[data-faq-extra]');
      var showMoreBtn = categoryBlock.querySelector('[data-hotpot-faq-show-more]');

      if (extraItems.length > 0 && showMoreBtn) {
        showMoreBtn.hidden = false;
        showMoreBtn.textContent = showMoreBtn.dataset.moreLabel || showMoreBtn.textContent;

        var originalMoreLabel = showMoreBtn.textContent;
        var lessLabel = 'Toon minder';

        showMoreBtn.addEventListener('click', function () {
          var isExpanded = showMoreBtn.classList.contains('is-expanded');

          if (!isExpanded) {
            extraItems.forEach(function (item) { item.hidden = false; });
            showMoreBtn.textContent = lessLabel;
            showMoreBtn.classList.add('is-expanded');
          } else {
            extraItems.forEach(function (item) {
              item.hidden = true;
              item.classList.remove('is-open');
              var answer = item.querySelector('[data-hotpot-faq-answer]');
              var icon = item.querySelector('.hotpot-info-faq-item__icon');
              if (answer) answer.hidden = true;
              if (icon) icon.textContent = '+';
            });
            showMoreBtn.textContent = originalMoreLabel;
            showMoreBtn.classList.remove('is-expanded');
          }
        });
      }
    });
  }

  function initProductAccordion() {
    var lists = document.querySelectorAll('.hotpot-info-faq-list[data-open-first], .hotpot-product-details .hotpot-info-faq-list');

    lists.forEach(function (list) {
      if (list.hasAttribute('data-hotpot-faq-categorized')) return;

      var items = list.querySelectorAll('[data-hotpot-faq-item]');

      items.forEach(function (item) {
        var toggleButton = item.querySelector('[data-hotpot-faq-toggle]');
        var answer = item.querySelector('[data-hotpot-faq-answer], .hotpot-info-faq-item__answer');
        if (!toggleButton || !answer) return;

        toggleButton.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          items.forEach(function (otherItem) {
            otherItem.classList.remove('is-open');
          });

          if (!isOpen) {
            item.classList.add('is-open');
          }
        });
      });

      if (list.hasAttribute('data-open-first') && items.length > 0) {
        items[0].classList.add('is-open');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBlog();
    initFaq(document);
    initProductAccordion();
  });

  /* --- Theme Editor: herinitialiseer bij sectie-herlaad --- */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section.querySelector('[data-hotpot-faq-category-block]')) initFaq(section);
    if (section.querySelector('[data-hotpot-blog]')) initBlog();
    if (section.querySelector('.hotpot-info-faq-list')) initProductAccordion();
  });

})();
